import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const WhatIsMentalNoiseSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel sectionId="what-is-mental-noise" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>
      Mental noise is the internal dialogue created when the mind repeatedly searches for certainty
      using past experiences, assumptions, fears, and unexamined interpretations instead of present facts.
    </GuideLead>
    <GuideSectionLabel>Common patterns</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="thinking" title="Replaying conversations" />
      <GuideCard iconKey="stress" title="Imagining negative outcomes" />
      <GuideCard iconKey="thinking" title="Creating stories without evidence" />
      <GuideCard iconKey="awareness" title="Seeking confirmation for beliefs" />
      <GuideCard iconKey="stress" title="Constant self-criticism" />
      <GuideCard iconKey="thinking" title='Endless "what if" thinking' />
    </GuideCardGrid>
    <GuideCallout>
      Mental noise is not reality. It is the mind filling gaps in evidence with stories.
    </GuideCallout>
    <GuideCallout variant="amber">
      Mental noise begins when we stop observing facts and start believing the stories our mind
      creates.
    </GuideCallout>
  </GuidePanel>
);

export default WhatIsMentalNoiseSection;
